import { Link, useParams } from "react-router-dom";

import { useLayoutContext } from "commons/context/layout";

import useUiExtenderPull from "commons/hooks/useUiExtenderPull";

import { PathWayType } from "commons/types/route";

import { GridItem, GridRow } from "commons/ui/Grid";

import { makeUrl } from "commons/utils/http";

type PropsType = {
    elements: Array<PathWayType>;
    maxPathWayElements?: number;
};

function PathWay({ elements, maxPathWayElements }: PropsType) {
    const elementsToRender: Array<JSX.Element> = [];

    let params = useParams();

    const { baseUiUrl } = useLayoutContext();

    const uiElements = useUiExtenderPull({ key: "right_pathway" });

    elements.forEach((element, index) => {
        if (index !== 0) {
            if (maxPathWayElements === undefined || index >= elements.length - maxPathWayElements) {
                elementsToRender.push(
                    <div className={"separator"} key={`separator-${element.path}-${element.label}`}>
                        <span>{"/"}</span>
                    </div>
                );
            }
        }

        if (maxPathWayElements === undefined || index >= elements.length - maxPathWayElements) {
            elementsToRender.push(
                <div
                    className={"path-container"}
                    key={`path-container-${element.path}-${element.label}`}
                >
                    {element.path ? (
                        <Link to={`${baseUiUrl ?? ""}${makeUrl(element.path, params)}`}>
                            {element.pathwayLabel ? element.pathwayLabel : element.label}
                        </Link>
                    ) : (
                        <span lang={element.lang}>{element.pathwayLabel ? element.pathwayLabel : element.label}</span>
                    )}
                </div>
            );
        }
    });

    return elementsToRender.length > 0 ? (
        <GridRow>
            <GridItem>
                <div className={"path-way"}>{elementsToRender.map((element) => element)}</div>
            </GridItem>

            {uiElements && <GridItem className={"right-path-way"}>{uiElements}</GridItem>}
        </GridRow>
    ) : null;
}

export default PathWay;
